import { useState } from "react";
import PrivacyPolicyModal from "@/components/PrivacyPolicyModal";

/**
 * PrivacyConsentNotice — un-checkbox compliance disclosure rendered above
 * every submit button on the site. Clicking the "Privacy Policy" link opens
 * a modal popup (not a new tab) so the user never leaves the form flow.
 *
 * Required by stricter compliance classifiers (Google Ads health-site
 * policy and similar) which demand a visible, hyperlinked Privacy Policy
 * reference at the point of data capture — without forcing the user to
 * tick a checkbox (which depresses conversion rates).
 */
export default function PrivacyConsentNotice({ className = "" }) {
  const [open, setOpen] = useState(false);

  return (
    <>
      <p
        className={`text-[11px] text-[#64748B] leading-relaxed text-center ${className}`}
        data-testid="privacy-consent-notice"
      >
        By submitting this form you agree to our{" "}
        <button
          type="button"
          onClick={() => setOpen(true)}
          className="text-[#F97316] underline hover:text-[#EA580C] focus:outline-none focus:ring-2 focus:ring-[#F97316]/30"
          data-testid="privacy-consent-link"
        >
          Privacy Policy
        </button>
        .
      </p>
      <PrivacyPolicyModal open={open} onOpenChange={setOpen} />
    </>
  );
}
